import axios from "axios";
import { serviceUrl } from "../../config";

const BACKEND_URL = serviceUrl;

export const getEmerlinkID = async (userid) => {
    try {
      const data = JSON.stringify({
        svc: "emerlink",
        pid: "RetrieveExtID",
        dat: {
            userid: userid,
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const getEmerlinkStatesAndCurrency = async (countrycode) => {
    try {
      const data = JSON.stringify({
        svc: "emerlink",
        pid: "getStatesAndCurrency",
        dat: {
            countrycode: countrycode,
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const EmerlinkCountryList = async (countrycode) => {
    try {
      const data = JSON.stringify({
        svc: "emerlink",
        pid: "EmerlinkCountryList",
        dat: {
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const registerEmerlinkUser = async (userid) => {
    try {
      const data = JSON.stringify({
        svc: "emerlink",
        pid: "registerEmerlinkUser",
        dat: {
            userid: userid
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const emerlinkLoad = async (userid) => {
    try {
      const data = JSON.stringify({
        svc: "emerlink",
        pid: "emerlinkLoad",
        dat: {
            userid: userid
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };
  export const getEmerlinkSendTransactionDetails = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "emerlink",
        pid: "EmerlinkGetSendTransDetail",
        dat: formdata
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const emerlinkSendMoney = async (formdata, userpin) => {
    try {
      formdata = {...formdata, PIN: userpin}
      const data = JSON.stringify({
        svc: "emerlink",
        pid: "emerlinkSendMoney",
        dat: formdata
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const emerlinkReceiveMoney = async (formdata, userpin) => {
    try {
      formdata = {...formdata, PIN: userpin}
      const data = JSON.stringify({
        svc: "emerlink",
        pid: "emerlinkReceiveMoney",
        dat: formdata
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const getEmerlinkReceiveTransaction = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "emerlink",
        pid: "EmerlinkGetReceiveTransDetail",
        dat: formdata
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const addEmerlinkContact = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "emerlink",
        pid: "createExternalContact",
        dat: formdata
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const emerlinkTrackTransfer = async (sessionid, referencenumber) => {
    try {
      const data = JSON.stringify({
        svc: "emerlink",
        pid: "EmerlinkGetTransaction",
        dat: {
          sessionid: sessionid,
          referencenumber: referencenumber,
          type: 'SND'
        }
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };